import { render, staticRenderFns } from "./CustomerFraud.vue?vue&type=template&id=f892e0ac&scoped=true&lang=pug&"
import script from "./CustomerFraud.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomerFraud.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CustomerFraud.vue?vue&type=style&index=0&id=f892e0ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f892e0ac",
  null
  
)

export default component.exports